{
  "id": "anubis",
  "pantheon": "egyptians",
  "name": {
    "pt-BR": "Anúbis",
    "en": "Anubis"
  },
  "icon": "gods/anubis",
  "portrait": "gods/anubis-portrait",
  "age": "classical",
  "freeUnitsOnAgeUp": {
    "anubite": 1
  },
  "unlocks": ["anubite", "feet-of-the-jackal", "necropolis", "serpent-spear"],
  "powers": ["plague-of-serpents"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml, minor_gods.xml, string_table.txt)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "God of judgment and the dead. Focus: Anubites and Monuments. Free unit(s) spawn at a Temple when the age-up completes. God power recharge 180 s."
  }
}
